import { getItem } from '../../../utils/StorageManager'
import { organizationType, planType, featuresType } from '@/utils/enumsUtils.js'

export default {
  isLoggedIn: (state) => state.isLogged || !!getItem('accessToken'),
  // DEPRECIADO
  // hasAccountType: state =>
  // {
  //   if (state.user) {
  //     return state.user.hasAccountType // state.AccountType !== 'Unknown', // Explicitando que esse valor tem que estar preenchido. Acredito que o tipo default, caso não definido, será Unknown
  //   } else {
  //     return false
  //   }
  // },
  isSendit: (state) => organizationType(state.session.organization.organizationType) == 'sendit',
  planType: (state) => planType(state.session.organization.planType),
  isActive: (state) => state.user.hasEmailValidated,
  authStatus: (state) => state.status,
  emailUser: (state) => state.user.email,
  IdAccount: (state) => state.user.accountId,
  IdUser: (state) => state.user.id,
  message: (state) => state.message,
  getPermissions: (state) => state.permissions,
  getFeatures:
    (state) =>
    (featureType = []) => {
      if (!state.session.features.length) {
        return []
      }

      if (!Array.isArray(featureType)) {
        return 'object invalid type'
      }

      if (!featureType.length) {
        return state.session.features.map((elm) => {
          return {
            type: featuresType(elm.featureType),
          }
        })
      }

      return state.session.features.filter((elm) => {
        if (featureType.includes(featuresType(elm.featureType))) {
          return elm
        }
      })
    },
  subOrganizationMaxCount: (state) => {
    if (!state.session.features.length) {
      return null
    }
    return JSON.parse(state.session.features.filter((el) => el.featureType == 2)[0].metaData).SubOrganizationMaxCount
  },

  featureCreateSubOrganizationEnabled: (state) => {
    if (!state.session.features.length) {
      return null
    }
    return JSON.parse(state.session.features.filter((el) => el.featureType == 2)[0].metaData).FeatureEnabled
  },
  hasSessionPermission: (state) => (permission) => {
    if (permission) {
      const sessionPermissions = state.session.permissions
      return sessionPermissions.find((sessionPermission) => sessionPermission.value === permission)
    } else {
      return false
    }
  },
  isOrganizationBase: (state) => (organizationId) => {
    return state.session?.organization?.organizationBaseId === organizationId
  },
}
